
import { defineComponent } from 'vue';
import { useDropdown, useLocale } from '@/composables';
import { LocaleOptions, Locales } from '@/config';
import { LocaleFlag } from '@/models';

export default defineComponent({
  name: "LocaleSwitch",
  setup() {
    const { setLocale } = useLocale();
    const { root, isExpanded, handleHover, open, close } = useDropdown();
    return { setLocale, root, isExpanded, handleHover, open, close };
  },
  computed: {
    selectedLocaleOption(): LocaleFlag {
      return Locales.find(o => o.locale === this.$i.locale) || {
        file: 'pl.svg',
        locale: LocaleOptions.PL,
      };
    },
    otherLocaleOptions(): LocaleFlag[] {
      return Locales.filter(o => o.locale !== this.$i.locale);
    },
  },
  methods: {
    selectLocale(locale: LocaleOptions): void {
      this.setLocale(locale);
      this.close();
    },
  },
});
